<template>
    <div id="user-form">
        <form @submit.prevent>
            <h2 v-if="client.first_name">
                Gostaríamos de saber um pouco mais sobre você
            </h2>
            <p>Complete seus dados para finalizar</p>
            <div
                class="form-question"
                v-if="form.askName !== 'no' && (!client.first_name || !client.last_name)"
            >
                <label for="user-first-name"> Nome </label>
                <input
                    id="user-first-name"
                    type="text"
                    v-model="first_name"
                    placeholder="Digite seu nome"
                    :required="form.askName === 'required'"
                    autocomplete="given-name"
                    :class="{'input-error': errors.first_name}"
                />
                <small v-if="errors.first_name" class="error-message">{{ errors.first_name }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askLastName !== 'no' && (!client.first_name || !client.last_name)"
            >
                <label for="user-last-name"> Sobrenome </label>
                <input
                    id="user-last-name"
                    type="text"
                    v-model="last_name"
                    placeholder="Digite seu sobrenome"
                    :required="form.askLastName === 'required'"
                    autocomplete="family-name"
                    :class="{'input-error': errors.last_name}"
                />
                <small v-if="errors.last_name" class="error-message">{{ errors.last_name }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askEmail !== 'no' && !this.client.email"
            >
                <label for="user-email"> E-mail </label>
                <input
                    id="user-email"
                    type="email"
                    v-model="email"
                    placeholder="Digite seu e-mail"
                    :required="form.askEmail === 'required'"
                    autocomplete="email"
                    :class="{'input-error': errors.email}"
                />
                <small v-if="errors.email" class="error-message">{{ errors.email }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askPhone !== 'no' && !this.client.whatsapp"
            >
                <label for="user-whatsapp"> Celular </label>
                <input
                    id="user-whatsapp"
                    type="tel"
                    v-model="whatsapp"
                    v-mask="'(##) #####-####'"
                    @input="isPhoneValid(whatsapp)"
                    placeholder="(99) 99999-9999"
                    :required="form.askPhone === 'required'"
                    autocomplete="tel"
                    :class="{'input-error': errors.whatsapp}"
                />
                <small v-if="errors.whatsapp" class="error-message">{{ errors.whatsapp }}</small>
            </div>
            <div
                class="form-question"
                v-if="form.askBirthdate !== 'no' && !this.client.birthdate"
            >
                <label for="user-birthdate"> Data de Nascimento </label>
                <input
                    id="user-birthdate"
                    type="tel"
                    v-model="birthdate"
                    v-mask="'##/##/####'"
                    placeholder="xx/xx/xxxx"
                    :required="form.askBirthdate === 'required'"
                    autocomplete="bday"
                    :class="{'input-error': errors.birthdate}"
                />
                <small v-if="errors.birthdate" class="error-message">{{ errors.birthdate }}</small>
            </div>
        </form>
    </div>
</template>
<style scoped>
.input-error {
    border: 1px solid #e74c3c !important;
}
.error-message {
    color: #e74c3c;
    font-size: 12px;
    margin-bottom: -18px;
    margin-top: -5px;
    display: block;
}
</style>
<script>
export default {
    name: "form-user",
    props: {
        client: Object,
        place: Object,
    },
    data: function () {
        return {
            first_name: this.client.first_name,
            last_name: this.client.last_name,
            email: this.client.email,
            whatsapp: this.client.whatsapp,
            birthdate: this.client.birthdate,
            errors: {
                first_name: null,
                last_name: null,
                email: null,
                whatsapp: null,
                birthdate: null,
            },
            saving: false,
        };
    },
    computed: {
        form() {
            return this.$store.state.form;
        },
    },
    methods: {
        getData: function () {
            let data = {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                whatsapp: this.whatsapp,
                birthdate: this.birthdate,
                password: this.password,
            };
            return data;
        },
        isEmailValid: function (email) {
            if (email === null || email === "") {
                if (this.form.askEmail === "required") {
                    return false;
                }
                return true;
            }
            var re =
                /^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var result = re.test(email);
            return result;
        },
        isPhoneValid: function (phone) {
            if (phone === null || phone === "") {
                if (this.form.askPhone === "required") {
                    return this.errors.whatsapp = "Por favor informe seu celular";
                }
                return this.errors.whatsapp = null;
            }

            // acept international numbers
            const digitsOnly = phone.replace(/\D/g, "");
            if (digitsOnly.length >= 10 && digitsOnly.length <= 15) {
                return this.errors.whatsapp = null;
            }

            const re = /^\(\d{2}\) \d{4,5}-\d{4}$/;
            const result = re.test(phone);
            if (!result) {
                return this.errors.whatsapp = "Por favor, informe um celular válido";
            }
            return this.errors.whatsapp = null;
        },
        isBirthDateValid: function (birthdate) {
            if (birthdate === null) {
                return true;
            }
            let re = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
            let result = re.test(birthdate);
            if (!result) {
                return false;
            }

            let datePieces = birthdate.split("/");
            if (parseInt(datePieces[0]) > 31 || parseInt(datePieces[0]) <= 0) {
                return false;
            }
            if (parseInt(datePieces[1]) > 12 || parseInt(datePieces[1]) <= 0) {
                return false;
            }
            if (
                parseInt(datePieces[2]) > 2019 ||
                parseInt(datePieces[2]) <= 1920
            ) {
                return false;
            }

            return result;
        },
        isValid: function () {
            if (!this.first_name && this.form.askName === "required") {
                this.errors.first_name = "Por favor informe seu nome";
            } else {
                this.errors.first_name = null;
            }

            this.isPhoneValid(this.whatsapp);

            if (!this.last_name && this.form.askLastName === "required") {
                this.errors.last_name = "Por favor informe seu sobrenome";
            } else {
                this.errors.last_name = null;
            }

            if (this.form.askBirthdate === "required" || this.birthdate) {
                if (!this.isBirthDateValid(this.birthdate)) {
                    this.errors.birthdate = "Por favor confira sua data de nascimento";
                } else {
                    this.errors.birthdate = null;
                }
            }

            if (!this.isEmailValid(this.email)) {
                this.errors.email = "Por favor informe seu email";
            } else {
                this.errors.email = null;
            }

            if (Object.values(this.errors).some((error) => error !== null)) {
                return false;
            }
            return true;
        },
    },
};
</script>
